'use strict';

// plugins
import mmenu from "../components/_base/header/mmenu.js";
import lazyLoad from "./modules/lazyload.js";
import fancybox from "./modules/fancybox.js";
import rutubeFbPlay from "../components/video/rutube-fb-play.js";
import slideToggle from "./modules/slideToggle.js";

// my plugins
import forms from "../components/forms/forms.js";
import widgetPhone from "../components/widget-phone/widget-phone.js";
import modalSlide from "../components/forms/modal-slide.js";
import geolocation from "../components/geolocation/geolocation.js";
import basket from "../components/cart/basket.js";
import animations from "../components/animations/animations.js";
import theme from "../components/theme/theme.js";

// main blocks
// import headerTopButton from "../components/_base/header/headerTopButton.js";
import priorityPlusNav from "../components/_base/menu-top/priorityPlusNav.js";
import mobileButtons from "../components/_base/header/mobileButtons.js";
import menuToggle from '../components/_base/menu-top/menuToggle.js';
import verticalMenu from "../components/_base/vertical-menu/vertical-menu.js";

// blocks
import tabs from "../components/tabs/tabs.js";
// import tags from "../components/tags/tags.js";
import details from "../components/details/details.js";
import sectionsSubPopup from "../components/sections-sub-popup/sections-sub-popup.js";

// sliders
import slider from '../components/sliders/slider/slider.js';
import sliderBg from '../components/sliders/slider-bg/slider-bg.js';
import sliderBgFw from '../components/sliders/slider-bg-fw/slider-bg-fw.js';
import sliderThumbs from '../components/sliders/slider-thumbs/slider-thumbs.js';
import sliderThumbsVertical from '../components/sliders/slider-thumbs/slider-thumbs-vertical.js';
import sliderCarousel from "../components/sliders/slider-carousel/slider-carousel.js";
import sliderSectionCarouselFunc from "../components/sliders/slider-carousel-section/slider-carousel-section.js";
import sliderReview from "../components/sliders/slider-review/slider-review.js";

// modules
import searchVariants from "../components/search/searchVariants.js";
import catalogPhoto from "../components/catalog/catalogPhoto.js";
import textClamp from "./modules/textClamp.js";
import copyListenerFunc from "./modules/copyListener.js";
import anchor from "./modules/anchor.js";
import landing from "./modules/landing.js";
import hiddenLink from "./modules/hiddenLink.js";
import tableArrows from "./modules/tableArrows.js";
import cookieWarning from "./modules/cookieWarning.js";
import scrollTop from "./modules/scrollTop.js";
import observerMap from "./modules/observerMap.js";
import contactsMap from "../components/contacts-where-buy/contactsMap.js";
import contactsListMap, {selectCity} from "../components/contacts-where-buy/contactsListMap.js";
import pagination from "../components/pagination/pagination.js";
import yaC from "./modules/yaC.js";

window.isMobile = document.body.classList.contains('is-mobile');
// const isMobile = document.body.classList.contains('is-mobile');

document.addEventListener('DOMContentLoaded', () => {

});

// plugins
mmenu();
lazyLoad();
fancybox();
rutubeFbPlay();
slideToggle();

// my plugins
forms();
if(onWidgetPhone){
    widgetPhone();
}
if(onModalSlide){
    modalSlide();
}
geolocation();
basket();
animations();
theme();

// main blocks
// headerTopButton(); // header__top-button visible
priorityPlusNav('menu-header'); // Верхнее меню - пункт Еще
mobileButtons();
verticalMenu();
priorityPlusNav('menu-top');
menuToggle(); // submenu-toggle

// blocks
details();
sectionsSubPopup();
tabs();
// tags();

// sliders
slider();
sliderBg();
sliderBgFw();
sliderThumbs();
sliderThumbsVertical();
sliderCarousel(); // not used
sliderSectionCarouselFunc();
sliderReview();

// modules
catalogPhoto();
searchVariants();
landing();
anchor();
hiddenLink(); // hidden link for seo
tableArrows();
cookieWarning();
scrollTop();
textClamp();
copyListenerFunc(); // add link to copied text
observerMap();
contactsMap();
contactsListMap(); // карта в "Где купить" со всеми объектами
selectCity();
if(onAjaxPagination){
    pagination();
}
yaC(); // get Ya.Metrika id (for reachGoal)








